import { loadVideoStreamMetadata } from '../../../utilities/VideoUtilities.js';
import { getGenericViewportSourceDataId } from '../genericViewportDisplaySetAccess.js';
export class DefaultVideoDataProvider {
    async load(dataId) {
        const sourceDataId = getGenericViewportSourceDataId(dataId);
        const stream = loadVideoStreamMetadata(sourceDataId);
        return {
            id: dataId,
            type: 'video',
            renderedUrl: stream.renderedUrl,
            fps: stream.cineRate || 30,
            numberOfFrames: stream.numberOfFrames || 1,
            frameRange: [1, stream.numberOfFrames || 1],
            modality: stream.modality,
            metadata: stream.metadata,
        };
    }
}
